<template>
  <!-- WARNING: prevent side effect. (neighbor window affected when before component resized) -->
  <!-- WARNING: even rendering time is different(chrome and firefox). set 0px, 0px won't render in chrome -->
  <div class="mdi-window__root" style="width: 1px; height: 1px">
    <div class="mdi-window__stem">
      <!-- header -->
      <window-header :title="title" @onMinimize="minimize"></window-header>
      <!-- body -->
      <transition name="slide-fade">
        <div class="truegaze-window__body elevation-24" v-show="!flags.collapse" style="position: relative">
          <span>
            <div v-if="this.flags.showConfirmDialog" class="mdi-window__confirm-dialog justify-center align-center">
              <div>
                <p>{{ confirmDialogMsg }}</p>
                <mdi-button class="confirm" @click="onClickConfirm">Confirm</mdi-button>
                <mdi-button @click="flags.showConfirmDialog = false">Deny</mdi-button>
              </div>
            </div>
            <div class="mdi-window__focus-curtain"></div>
            <slot></slot>
          </span>
        </div>
      </transition>
      <!-- <window-loader v-if="options.useLoader"></window-loader> -->
    </div>
  </div>
</template>

<script>
import theme from '../class/Theme';

import WindowHeader from './WindowHeader.vue';
import { makeResizable, makeDraggable } from '../utils/make-interactable';
import { setWidth, setHeight, setStyle } from '../utils/dom-helper';
import { defaultSizes } from '../constatns/settings';

export default {
  components: {
    WindowHeader,
  },
  props: {
    windowEventBus: Object,
    terminateAction: Function, // TODO: not yet impl
    windowOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      beforeMinimizeHeight: undefined,
      flags: {
        collapse: false,
        showConfirmDialog: false,
      },
      options: {
        minimizable: false,
      },
      title: undefined,
      confirmDialogMsg: undefined,
    };
  },
  mounted() {
    this.bindComponent();

    setStyle(this.$el.querySelector('.truegaze-window__body'), { background: theme.getWindowBodyColor() });
  },
  methods: {
    bindComponent(windowOptions) {
      const { labels = {} } = this.windowOptions;
      this.title = labels.title;

      // parse component attribute
      const { mode = 'static', draggable = true, minimizable = false, initSize = {}, minSize = {} } =
        this.windowOptions || {};

      const stemEl = this.$el.querySelector('.mdi-window__stem');
      const headerEl = this.$el.querySelector('.mdi-window__header');
      const bodyEl = this.$el.querySelector('.truegaze-window__body');

      if (mode === 'static') {
        // not yet impl
      } else if (mode === 'fit-content') {
        bodyEl.style.width = 'fit-content';
        bodyEl.style.height = 'fit-content';
      } else if (mode === 'resizable') {
        const initWidth = initSize.w || defaultSizes.initSize.w;
        const initHeight = initSize.h || defaultSizes.initSize.h;
        initWidthHeight(stemEl, { initWidth, initHeight });

        const minWidth = minSize.w || defaultSizes.minSize.w;
        const minHeight = minSize.h || defaultSizes.minSize.h;
        makeResizable(bodyEl, stemEl, { minWidth, minHeight });
      } else {
        throw new Error(`You should declare 'mode' property for create window. mode=[${mode}]`);
      }

      if (draggable) {
        makeDraggable(headerEl, stemEl);
      }

      if (minimizable === false) {
        this.options.minimizable = false;
      } else {
        this.options.minimizable = true;
      }
    },
    enableCurtain(flag) {
      const el = this.$el.querySelector('.mdi-window__focus-curtain');
      if (flag) {
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    },
    setFocus(flag) {
      const el = this.$el.querySelector('.mdi-window__focus-curtain');
      if (flag) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    },
    toggle() {
      this.flags.collapse = !this.flags.collapse;
    },
    minimize($event) {
      this.$emit('minimize', this.title);
    },
    // maximize() {
    //   this.flags.collapse = false;

    //   // pop current height
    //   if (this.beforeMinimizeHeight) {
    //     const rootEl = this.$el.querySelector('.mdi-window__stem');
    //     rootEl.style.height = this.beforeMinimizeHeight;
    //   }
    // },
    onNotifyInfo(msg) {
      this.infoMsg = msg;

      setTimeout(() => {
        this.infoMsg = undefined;
      }, 1000);
    },
    onNotifyConfirm(msg, successCallback) {
      // show dialog
      this.flags.showConfirmDialog = true;
      this.confirmDialogMsg = msg;
      this.$options.confirmCallback = successCallback;
    },
    onClickConfirm() {
      const callback = this.$options.confirmCallback;
      this.flags.showConfirmDialog = false;
      callback();
    },
  },
};

function initWidthHeight(rootEl, { initWidth, initHeight }) {
  setWidth(rootEl, initWidth || defaultSizes.width);
  setHeight(rootEl, initHeight || defaultSizes.height);
}
</script>

<style scoped>
.mdi-window__stem {
  --window-header-height: 22px;
  width: fit-content;
  height: fit-content;
  /* width: fit-content;
  width: -moz-fit-content;
  height: fit-content;
  height: -moz-fit-content; */
  /* Not yet used */
  --window-base-width: 50px;
  box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2), 0 21px 33px 3px rgba(0, 0, 0, 0.14),
    0 8px 40px 7px rgba(0, 0, 0, 0.12) !important;
}

.mdi-window__header {
  color: black;
  width: 100%;
  height: var(--window-header-height);
  background-color: #fff;
  background: linear-gradient(to bottom, #e6e6e6, #c4c4c4);
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #9e9e9e;
  overflow: hidden;
}

.mdi-window__header-text {
  text-transform: capitalize;
}

.truegaze-window__body {
  /* width: fit-content;
  width: -moz-fit-content; */
  height: calc(100% - var(--window-header-height));
  background: var(--mdi-bg-grey-1);
  border-radius: 0px 0px 4px 4px;
  overflow: hidden;
  padding: 0px;
}

.mdi-window__focus-curtain {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.mdi-window__confirm-dialog {
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000000c7;
  z-index: 99;
}
</style>
